import { euiPaletteColorBlindBehindText } from "@inscopix/ideas-eui";
import { ModelSchema } from "api/client/types/DjangoClient.types";

const colors = euiPaletteColorBlindBehindText({ sortBy: "natural" });

type ColorsByRunStatus = {
  [status in ModelSchema["RunSchema"]["status"]]: string;
};

export const colorsByRunStatus: ColorsByRunStatus = {
  1: colors[8],
  2: colors[1],
  3: colors[5],
  4: colors[0],
} as const;
